
import '../../../../../campaigns/ESG/ESGDesign2SignUpPage.css';
import '../../../../../campaigns/ICP4/ICP4SignUpPage.css';
import {
    Box,
    TextField,
    Typography,
} from '@mui/material';
import {Button} from "semantic-ui-react";
import axios from "axios";
import { registerVendorLinkingViaAccessToken } from '../../energy-device-oems.client';
import { useState } from 'react';
import { VENDOR_LIST } from '../../constants';

interface SungrowLoginData {
    userName: string;
    password: string; 
}

export function SungrowLoginForm({companyId, onLoginInit,
    onSuccessfullLogin,
    onFailedLogin}: {companyId: string,
    onSuccessfullLogin: () => void, 
    onFailedLogin:(errorMsg?: string | null)=>void;
    onLoginInit:()=>void;
}) {
    const [sungrowLoginData, setSungrowLoginData] = useState<SungrowLoginData>({userName: '', password: ''});
    const [isLoading, setIsLoading] = useState(false);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setSungrowLoginData((prev)=>{
          return {...(prev ?? {}), [e.target.name]: e.target.value}
        })
      }

    const linkSungrowVendor = async (e: any) => {
        e.preventDefault();
        setIsLoading(true);
        onLoginInit();
        const vendorId = 'SUNGROW-AUSTRALIA';
        if(sungrowLoginData.userName === '' || sungrowLoginData.password === ''){
          onFailedLogin('User name and password are required');
          return;
        }

        try {
          const loginResponse = await sungrowLogin(sungrowLoginData.userName, sungrowLoginData.password);
          const accessToken = loginResponse["result_data"].token;
          await registerVendorLinkingViaAccessToken(companyId, "SUNGROW-AUSTRALIA", accessToken);
          onSuccessfullLogin();
        } catch (err) {
          console.error('Error linking sungrow vendor:', err);
          onFailedLogin(`Failed to link with ${VENDOR_LIST.find((v)=> v.id===vendorId)?.name} please make sure your credentials are correct.`);
        } finally {
          setIsLoading(false);
        }
      }

      return <div id={"icp4"}>
      <div>
              <Box
                  component="form"
                  className="formContainer"
                  onSubmit={linkSungrowVendor}
              >
                  <div className="formHeader">
                      <Typography variant="h2" component="h2">
                          Login to Sungrow
                      </Typography>
                      <Typography variant="body2">
                          Get started by connecting your Sungrow account now.
                      </Typography>
                  </div>

                  {/* User Name */}
                  <Box className="field">
                      <TextField
                          fullWidth
                          required
                          label="User Name"
                          name="userName"
                          value={sungrowLoginData?.userName}
                          onChange={handleChange}
                      />
                  </Box>

                  {/* Password */}
                  <Box className="field">
                      <TextField
                          fullWidth
                          required
                          type="password"
                          label="Password"
                          name="password"
                          value={sungrowLoginData?.password}
                          onChange={handleChange}
                      />
                  </Box>
              <Button
                  primary
                  type="submit"
                  className="raised"
                  size="huge"
                  style={{
                    marginTop: '1rem',
                  }}
                  loading={isLoading}
                  disabled={isLoading}
              >
                  Login
              </Button>
              </Box>
      </div>
  </div>
}

const baseUrl = 'https://augateway.isolarcloud.com';

async function sungrowLogin(username: string, password: string): Promise<any> {
    const url = `${baseUrl}/v1/userService/login`;
    const response = await axios.post(url,{
        appkey: "ANDROIDE13EC118BD7892FE7AB5A3F20",
        user_account: username,
        user_password: password,
        "sys_code": "900",
    } , {
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
      },
  });
    if(response.data.result_code !== '1' || !response.data["result_data"]?.token) {
      console.error('Failed to login to Sungrow:', response.data);
      throw new Error('Login failed');
    }
    return response.data;
}
